module.exports = __webpack_public_path__ + "static/media/ratchetbg.6575123f.jpg";